import type { LucideIcon } from "lucide-react";

type FeatureCardProps = {
  title: string;
  body: string;
  icon?: LucideIcon;
  dark?: boolean;
  badge?: string;
};

export function FeatureCard({ title, body, icon: Icon, dark = false, badge }: FeatureCardProps) {
  return (
    <article className={`feature-card ${dark ? "feature-card-dark" : ""}`}>
      {Icon ? (
        <div className="feature-icon" aria-hidden="true">
          <Icon size={22} />
        </div>
      ) : null}
      <h3>{title}</h3>
      {badge ? <span className="feature-badge">{badge}</span> : null}
      <p>{body}</p>
    </article>
  );
}
